module.exports = __webpack_public_path__ + "static/media/mob-img.38825c9d.png";